import { useEffect, useState } from 'react'
import makeAnimated from 'react-select/animated';
import AsyncSelect from 'react-select/async';
import useGetHook from '../../customHooks/useUserServiceGetHook';

const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const { register, setValue, label, queryKey, url, value, props: otherProps } = props
  const limit = 10
  const [query, setQuery] = useState("");
  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${query}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: query,
      ...otherProps,
    },
  });
  const [defaultValue, setDefaultValue] = useState([...value])
  const onChange = (value: any) => {
    setValue(register?.name, value)
    setDefaultValue(value)
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setQuery(inputValue?.length == 1 ? "" : inputValue)
    setTimeout(() => {
      callback(serverData?.results?.map((item: any, index: number) => ({ label: item?.name, value: item?.pk })));
    }, 1000);
  };

  return (
    <div className='mt-4'>
      <label htmlFor="">{label}</label>
      <AsyncSelect
        defaultValue={defaultValue}
        loadOptions={loadOptions}
        components={animatedComponents}
        closeMenuOnSelect={false}
        onChange={onChange}
        isMulti
        defaultOptions={serverData?.results?.map((item: any, index: number) => ({ label: item?.name, value: item?.pk })) ?? []}
      />

    </div>
  )
}

export default MultipleSelectField